/**
 * Whether the table can be deleted (true only when a delete handler is provided).
 */
export function computeCanDeleteTable(deleteHandler: (() => void) | undefined): boolean {
  return deleteHandler != null;
}

/**
 * Whether the table can be renamed (renaming is allowed and not hidden).
 */
export function computeCanRenameTable(hideRename: boolean, canRename: boolean): boolean {
  return !hideRename && canRename;
}
